module.exports = __webpack_public_path__ + "static/media/fylogo_primary_color.ea7d37b5.svg";